/**
 * @generated SignedSource<<6459e3b0728ceed51eda940a82efb789>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type groupTableBody_nativeIssueTable_project$data = {
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"rows_jiraProject">;
  readonly " $fragmentType": "groupTableBody_nativeIssueTable_project";
};
export type groupTableBody_nativeIssueTable_project$key = {
  readonly " $data"?: groupTableBody_nativeIssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupTableBody_nativeIssueTable_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "groupTableBody_nativeIssueTable_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "rows_jiraProject"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "b6019a485ee13ec38df04bd759772c97";

export default node;
